import smoothscroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothscroll.polyfill();
export function scrollToTop(element, offset) {
    var window = element.ownerDocument.defaultView;
    var rect = element.getBoundingClientRect();
    const scrollOffsetY = rect.top - offset;
    window.scroll({
        left: window.scrollX,
        top: window.scrollY + scrollOffsetY,
        behavior: 'smooth'
    });
}
export function scrollToCenter(element) {
    var window = element.ownerDocument.defaultView;
    var rect = element.getBoundingClientRect();
    const targetY = (window.innerHeight - element.offsetHeight) * 0.5;
    const scrollOffsetY = rect.top - targetY;
    const targetX = (window.innerWidth - element.offsetWidth) * 0.5;
    const scrollOffsetX = rect.left - targetX;
    const thresholdY = (window.innerHeight - 200) * 0.5;
    const thresholdX = (window.innerWidth - 200) * 0.5;
    if (Math.abs(scrollOffsetY) > thresholdY) {
        window.scroll({
            left: window.scrollX,
            top: window.scrollY + scrollOffsetY,
            behavior: 'smooth'
        });
    }
    if (Math.abs(scrollOffsetX) > thresholdX) {
        window.scroll({
            left: window.scrollX + scrollOffsetX,
            top: window.scrollY,
            behavior: 'smooth'
        });
    }
    if (window.parent !== window) {
        // We are inside a scrollable element.
        var frame = window.frameElement;
        scrollToCenter(frame);
    }
}
